export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const hasPermission = (permissionMap, permission) => {
  if (!permissionMap) {
    return false;
  }
  return !!permissionMap[permission];
};

/**
 * Truncate a string and add an ellipsis if it exceeds the specified length.
 * @param {string} str - The string to truncate.
 * @param {number} maxLength - The maximum length of the string before truncation.
 * @returns {string} - The truncated string with an ellipsis if it exceeds the maxLength.
 */
export const truncateWithEllipsis = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength) + '...';
};

export const toRomanNumeral = (num) => {
  const roman = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
  return roman[num - 1] || num;
};


export const trimString = (str) => {
  return str.replace(/^\s+|\s+$/g, '');
};


export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};